import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DELETE: `${cleanedFilename(__filename)}-delete`,
  EDITABLE_TEXT: `${cleanedFilename(__filename)}-editable-text`,
  SAVE_BAR: `${cleanedFilename(__filename)}-save-bar`,
  MODAL: `${cleanedFilename(__filename)}-modal`,
};
